export const SET_CONFIG = 'SET_CONFIG';
export const SET_CUSTOMER_ID = 'SET_CUSTOMER_ID';
export const UPDATE_LOGGED_IN = 'UPDATE_LOGGED_IN';
export const SET_LOGIN_PENDING = 'SET_LOGIN_PENDING';
export const SET_FETCH_TIMESTAMP = 'SET_FETCH_TIMESTAMP';
export const SET_CUSTOMER_INFO = 'SET_CUSTOMER_INFO';
export const SET_ACTIVE_PAYMENT = 'SET_ACTIVE_PAYMENT';
export const SET_PAYMENTS_TAB_ID = 'SET_PAYMENTS_TAB_ID';
